export default __webpack_public_path__ + "static/media/Banner-Form-Artistica.235aa4ce.png";